<template>
  <v-app id="flex" class="grey lighten-4">
    <v-alert type="warning"
      >We have released a new Admin Portal. Please Switch to
      <a class="white--text" href="https://admin.cloudhexa.com.au/"
        >https://admin.cloudhexa.com.au/</a
      >
    </v-alert>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import mobileNav from "@/components/mobileNav";
import loading from "@/components/loading";
import Breadcrumb from "./components/Breadcrumb.vue";
import userNotAdmin from "@/components/userNotAdmin.vue";
import "../public/css/style.scss";
import loadingBG from "@/components/loading_bg";
import { mapState } from "vuex";
export default {
  name: "App",

  data() {
    return {};
  },
  computed: {
    ...mapState(["adminUser", "breadcrumb", "loading", "loadingBG"]),
  },
  created() {
    window.getApp = this;
  },
  components: {
    Navbar,
    mobileNav,
    Breadcrumb,
    userNotAdmin,
    loadingBG,
    loading,
  },
};
</script>
